import { getCurrentAcademicYear } from "../../../../utils/smallHelpers";
import {SET_FORM_DATA} from "../summGraduatesOrientationReducer";


const initialState = {
    year: getCurrentAcademicYear(),
    school: "0"
};

export const formReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FORM_DATA:
            return action.payload;
        default:
            return state;
    }
};
